module.exports = __webpack_public_path__ + "static/img/scenarios1_pho.d16d089.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scenarios1_pho.png
// module id = 8jaa
// module chunks = 0